module.exports = __webpack_public_path__ + "img/landmark.2467d0c1.jpg";